export const DOCUMENT_WIZARD_STEP_COUNT = 2;

export function getAddDocumentWizardChromeProps(stepIndex, t) {
  const isUploadStep = stepIndex === 0;

  return {
    stepIndex,
    displayTotalSteps: DOCUMENT_WIZARD_STEP_COUNT,
    title: t('Add File', { defaultValue: 'Add File' }),
    stepName: isUploadStep
      ? t('Upload', { defaultValue: 'Upload' })
      : t('Visible to', { defaultValue: 'Visible to' }),
    stepDescription: isUploadStep
      ? t('add_document_step_upload_description', {
          defaultValue:
            'Upload a document for your building. You\'ll choose who can see it in the next step.'
        })
      : t('add_document_step_visibility_description', {
          defaultValue: 'Choose where this document applies and who can see it.'
        })
  };
}
